import { useQuery } from "react-query";

import useAxios from "@src/config/axios/useAxios";
import { ADMIN_IMPERSONATE_USERS_ENDPOINT } from "@src/config/baseUrls";
import { queryKeys } from "@src/config/queryKeys";
import { ImpersonatedUserData } from "@src/common/helpers/impersonatedUser";

const useUsers = () => {
  const axios = useAxios();

  return useQuery<ImpersonatedUserData[]>(
    queryKeys.IMPERSONATE_USERS,
    async () => {
      const { data } = await axios.get(`${ADMIN_IMPERSONATE_USERS_ENDPOINT}`);
      return data;
    },
  );
};

export default useUsers;
